import { render } from "./PcInputBody.vue?vue&type=template&id=9962b1b4"
import script from "./PcInputBody.vue?vue&type=script&lang=js"
export * from "./PcInputBody.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__